import { PageHeader } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { RevxButton } from 'components/RevxButton';
import { buildCreateRevshopShippingMarkupParam } from 'domains/markupDomain';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ShippingMarkupItemForm from './ShippingMarkupItemForm';
import ShippingMarkupTable from './ShippingMarkupTable';

const RevshopShippingMarkupTab = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const curItem = useAppSelector((state) => state.markup.curShippingMarkup);

  return (
    <>
      <PageHeader
        ghost={false}
        extra={[
          <RevxButton
            key="create"
            type="primary"
            onClick={() => {
              dispatch.markup.saveMarkup(
                buildCreateRevshopShippingMarkupParam()
              );
            }}
          >
            {t('platform.markup.titles.create')}
          </RevxButton>,
        ]}
      />

      {curItem && <ShippingMarkupItemForm />}
      <ShippingMarkupTable />
    </>
  );
};

export default RevshopShippingMarkupTab;
